export default {
  DISPLAYED: 'Announcement displayed',
  CLICKED: 'Announcement clicked',
  CLOSED: 'Announcement closed',
  CTA_TYPE: {
    primary: 'primary',
    secondary: 'secondary',
  },
};
